import { serverInfo } from "../config/serverConfig";
import { checkResponse } from "../utils/apiError";


import { apiFetch } from "./apiFetch";

/**
 * Account events list (same payload as Event Management / Participants filters).
 * @param {{ account_id: string }} params
 * @returns {Promise<object[]>}
 */
export async function fetchEvents({ account_id }) {
  if (!account_id) throw new Error("account_id is required");
  const resp = await apiFetch(serverInfo.serverUrl + "/getEvent", {
    method: "POST",
    body: JSON.stringify({ account_id }),
  });
  checkResponse(resp);
  const data = await resp.json();
  return Array.isArray(data) ? data : [];
}

/**
 * Bulk update one or more fields across many events.
 * Body: { account_id, _ids, event_date?, program_id?, event_organizer_id?, location?, visibility?, audience_type?, max_capacity?, viewer_time_zone? }
 * Returns { matched, modified }.
 */
export async function bulkUpdateEvents(payload) {
  const resp = await apiFetch(serverInfo.serverUrl + "/bulkUpdateEvents", {
    method: "POST",
    body: JSON.stringify(payload),
  });
  checkResponse(resp);
  if (!resp.ok) {
    const text = await resp.text();
    throw new Error(text || "Bulk update failed");
  }
  return resp.json();
}
